import industryReportHeader from '../../../img/industryReportHeader.svg';
import { Box, Heading, Text } from '@zillow/constellation-10';
import type React from 'react';
import { SalesProCard } from '../../SharedComponents/SalesProCard';
import { CustomerAnalyticsMoodysWebApiHandler_canUserDownloadPremiumReport } from '@zg-rentals/ts-customer-analytics-client';
import { useAsync } from 'react-use';
import { httpClient } from '../../../httpClient';

export const IndustryReportsSidebar = () => {
  const { value: userIsSignature = false } = useAsync(
    async () => CustomerAnalyticsMoodysWebApiHandler_canUserDownloadPremiumReport(httpClient),
    [],
  );
  const ListItem = ({ children }: { children: React.ReactNode }) => (
    <li style={{ display: 'list-item', marginBottom: '15px' }}>{children}</li>
  );
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
      <Box css={{ padding: '400' }}>
        <Box css={{ display: 'flex', justifyContent: 'center', marginBlock: '600' }}>
          <img src={industryReportHeader.src} alt="Market intelligence" />
        </Box>
        <Heading level={5} css={{ marginBlockEnd: '400' }}>
          Market intelligence, delivered
        </Heading>
        <Text css={{ marginBottom: 'md', lineHeight: '1.5' }}>
          {userIsSignature ? 'Your' : 'A'} Signature package includes access to exclusive market reports, including
          Moody&apos;s advanced market reports. Updated quarterly, these reports include:
        </Text>

        <ul style={{ paddingLeft: '10px', listStyle: 'disc', marginTop: '25px' }}>
          <ListItem>
            <Text css={{ fontWeight: 'bold' }}>Market forecasts</Text>
            <Text> to inform confident decisions and highlight opportunities for owners</Text>
          </ListItem>
          <ListItem>
            <Text css={{ fontWeight: 'bold' }}>Competitive pricing insights</Text>
            <Text> to help sharpen your pricing strategy and optimize your spend</Text>
          </ListItem>
          <ListItem>
            <Text css={{ fontWeight: 'bold' }}>Deep dives into submarkets</Text>
            <Text> so you can fine tune your strategy where it matters most</Text>
          </ListItem>
          <ListItem>
            <Text css={{ fontWeight: 'bold' }}>Trend identification</Text>
            <Text> to help you plan upgrades and marketing strategy</Text>
          </ListItem>
        </ul>
      </Box>
      <SalesProCard
        title={userIsSignature ? 'Get a report walkthrough' : 'Unlock a new level of insight'}
        description={
          userIsSignature
            ? 'Dive deeper into this data by scheduling a call with your sales pro.'
            : "Upgrade to Signature to access Moody's advanced market reports."
        }
        buttonText={userIsSignature ? 'Connect with [sales pro name]' : 'Contact our sales team'}
      />
    </Box>
  );
};
